/**
 * Strips a leading `@` and surrounding whitespace from a social media handle.
 * Returns `null` if the handle is missing, or empty after normalization, so
 * callers can use a single truthiness check before rendering anything that
 * depends on a usable handle.
 */
export function normalizeHandle(handle?: string | null): string | null {
	if (!handle) return null;
	const stripped = handle.trim().replace(/^@+/, '').trim();
	return stripped.length > 0 ? stripped : null;
}
